import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Download } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { Logo } from '../common/Logo';

export const Navbar: React.FC = () => {
  const { isAuthenticated } = useAuth();

  return (
    <header className="fixed top-0 left-0 right-0 w-full z-50 bg-white/95 dark:bg-[#1a1b4b]/95 backdrop-blur-xl border-b border-[#3e4491]/20 shadow-sm transition-all">
      <div className="max-w-7xl mx-auto flex items-center justify-between px-4 sm:px-6 lg:px-8 h-18 py-3">
        {/* Brand Logo */}
        <Link to="/" className="flex items-center transition-transform hover:scale-[1.02]">
          <Logo size="md" />
        </Link>

        {/* Center Navigation Links Box */}
        <nav className="hidden md:flex items-center gap-7 text-sm font-medium text-[#1a1b4b] dark:text-slate-200 bg-[#F8FAFC] dark:bg-[#292a73]/40 px-6 py-2 rounded-full border-2 border-[#3e4491]/25 dark:border-[#3e4491] shadow-xs backdrop-blur-md">
          <Link to="/features" className="transition hover:text-[#3a9efd] font-bold">
            Features
          </Link>
          <Link to="/pricing" className="transition hover:text-[#3a9efd] font-bold">
            Pricing
          </Link>
          <Link to="/download" className="transition hover:text-[#3a9efd] font-bold flex items-center gap-1.5">
            <Download className="h-3.5 w-3.5 text-[#3a9efd]" /> Download
          </Link>
        </nav>

        {/* Right Authentication Actions */}
        <div className="flex items-center gap-3">
          <Link
            to="/login"
            className="text-sm font-bold text-[#1a1b4b] dark:text-slate-200 hover:text-[#3a9efd] px-3.5 py-1.5 transition hidden sm:inline-block"
          >
            Sign In
          </Link>
          {isAuthenticated ? (
            <Link
              to="/app"
              className="inline-flex items-center justify-center gap-2 rounded-full bg-[#1a1b4b] hover:bg-[#292a73] px-5 py-2.5 text-sm font-bold text-white shadow-md shadow-[#1a1b4b]/20 transition hover:-translate-y-0.5 border border-[#3e4491]/30"
            >
              <span>Get Started</span>
              <ArrowRight className="h-4 w-4 text-[#f7a400]" />
            </Link>
          ) : (
            <Link
              to="/register"
              className="inline-flex items-center justify-center gap-1.5 rounded-full bg-[#1a1b4b] hover:bg-[#292a73] px-5 py-2.5 text-sm font-bold text-white shadow-md shadow-[#1a1b4b]/20 transition hover:-translate-y-0.5 border border-[#3e4491]/30"
            >
              <span>Get Started</span>
              <ArrowRight className="h-4 w-4 text-[#f7a400]" />
            </Link>
          )}
        </div>
      </div>
    </header>
  );
};
